__turbopack_context__.v({
  "container": "ProductSelection-module-scss-module__CVGpba__container",
  "contentContainer": "ProductSelection-module-scss-module__CVGpba__contentContainer",
  "disabled": "ProductSelection-module-scss-module__CVGpba__disabled",
  "selectable": "ProductSelection-module-scss-module__CVGpba__selectable",
});
